import React, {MouseEventHandler, useEffect, useState} from "react"
import "./index.scss"
import {CommonButton, Loading} from "../Button";
import {shortenString} from "../../utils/util";
import {mainApi} from "../../api/main";
import {message, Tooltip} from "antd";
import {useInit} from "../../utils/useInit";
import {useMinersStore} from "../../redux/features/miners";
import {Principal} from "@dfinity/principal";
import useWindowSize from "../../hook/Resize";
import {Content} from "../Content";
import {useDashboardStore} from "../../redux/features/dashboard";
import Modal from "../Modal";

const title = ["Canister Id", "Cycle Balance", "Block Mined", "Power", "Staking Status"]
const cycleDeleted = 0.2 * 1e12 // 0.2 T
export const Mining = () => {
  const {width} = useWindowSize();
  const {setLoading, refresh, principal} = useInit()
  const {stakingBalances, stakingPoints} = useMinersStore()
  const [upgradeLoading, setUpgradeLoading] = useState<number[]>([])
  const [isOpen, setOpen] = React.useState(false)
  const [code, setCode] = React.useState<string>("")

  const stakingStatus = React.useMemo(() => {
    if (!stakingPoints || !stakingBalances) return undefined
    return stakingPoints.map((v, k) => {
      if (v === 0 && stakingBalances[k] === 0) return "None"
      if (v === 0 && stakingBalances[k] > 0) return "In Effect"
      return "Active"
    })
  }, [stakingPoints, stakingBalances])

  const upgrade = async (isDepleted: boolean, cid: Principal, k: number) => {
    if (isDepleted) {
      return message.warning("This miner is depleted")
    }
    const isConfirm = window.confirm(`Are you sure you want to spend ${upgradeAmount} ICP to upgrade this miner?`)
    if (!isConfirm) return
    const arr = [...upgradeLoading, k]
    message.info(`Please wait for approximately 2 minutes for the process to complete. During this time,please do not refresh the page.`)
    try {
      setUpgradeLoading(arr)
      await mainApi.old_for_new(cid)
      message.success("You need to wait 1 hour for the Staking Power to display")
    } catch (e: any) {
      message.warning(e.message ?? e)
    } finally {
      principal && await mainApi.initState(principal)
      const newArray = arr.filter(item => item !== k);
      setUpgradeLoading(newArray)
    }
  }

  const create = async () => {
    try {
      setLoading(true)
      message.info({
        content: "Please wait for approximately 2 minutes for the process to complete. During this time" +
          "please do not refresh the page.",
      })
      setOpen(false)
      await mainApi.create_miner(code)
    } catch (e: any) {
      message.error(e.message)
    } finally {
      setLoading(false)
      refresh()
    }
  }


  return <div className={"mining"}>
    <div style={{display: "flex", width: "100%", gap: "10px"}}>
      {isOpen && <ReferModal onOk={create} code={code} setCode={setCode} isOpen={isOpen} setOpen={setOpen}/>}
      <CommonButton text={"new miner"} handleClick={() => setOpen(true)} needLoading={true}/>
      <CommonButton text={"refresh"} handleClick={refresh} needLoading={true}/>
    </div>
    {width < 500 ? <MobileMinerList loading={upgradeLoading} upgrade={upgrade} stakingStatus={stakingStatus}/> :
      <MinerList loading={upgradeLoading} upgrade={upgrade} stakingStatus={stakingStatus} small={width < 920}/>}
  </div>
}

const ReferModal = React.memo(({isOpen, setOpen, code, setCode, onOk}: {
  isOpen: boolean,
  setOpen: Function,
  setCode: Function,
  code?: string, onOk: Function
}) => {

  return <Modal onOk={onOk} setOpen={setOpen} isOpen={isOpen}>
    <div className={"refer_modal_content"}>
      <h4>Please Enter The Referral Code (Optional)</h4>
      <div className={"refer_modal_content_input_wrap"}>
        <input value={code} onChange={e => setCode(e.target.value)} className={"refer_modal_content_input"}
               type="text"/>
        <Tooltip
          title={"Have a referral code? Enter it here to earn bonuses for both you and your referrer! It is optional"}>
                    <span className={"refer_modal_content_input_wrap_tip"}>
                    <svg className="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="2298" width="20px" height="20px"><path
                      d="M511.84970703 62.82177734c58.33300781 0 115.43203125 11.10322266 169.18417969 32.95634766 55.68925781 22.55712891 105.73945312 55.86591797 148.7399414 98.68974609 43.00136719 43.00048828 76.134375 93.05068359 98.690625 148.74082032 21.853125 53.92705078 32.95634766 110.85029297 32.95634766 169.18417968 0 58.33300781-11.10322266 115.43291016-32.95634766 169.18330079-22.55800781 55.69101563-55.86503906 105.73945312-98.690625 148.74082031-43.00048828 43.00136719-93.04980469 76.13349609-148.7399414 98.690625-53.92792969 21.853125-110.85029297 32.95546875-169.18417969 32.95546875-58.33300781 0-115.43291016-11.10234375-169.18330078-32.95546875-55.69101563-22.55712891-105.74033203-55.86591797-148.74082031-98.690625C150.92421875 787.315625 117.79296875 737.26542969 95.23496094 681.57617188 73.38183594 627.64736328 62.27949219 570.725 62.27949219 512.39199219c0-58.33388672 11.10322266-115.43291016 32.95546875-169.18417969 22.55800781-55.69013672 55.86591797-105.74033203 98.690625-148.74082031 43.00048828-43.00048828 93.05068359-76.13349609 148.74082031-98.6897461C396.41679688 73.925 453.34091797 62.82089844 511.84970703 62.82089844z m0.70576172 191.56552735c-47.05488281 0-84.94541016 12.68876953-113.67070313 37.89052734-28.55039062 25.37753906-45.82089844 61.68076172-51.63574218 109.2647461l64.32451172 7.57617187c5.6390625-35.59833984 17.27050781-61.50410156 35.24589843-78.24638672 17.80048828-16.74316406 40.18183594-25.02509766 66.79160157-25.02509765 27.66972656 0 50.93261719 9.34013672 69.96621093 27.66796875 19.03271484 18.32871094 28.54951172 39.82939453 28.54951172 64.14960937 0 13.39365234-3.34863281 25.90576172-9.69433593 37.18564453-6.51972656 11.278125-20.61914063 26.61064453-42.29472657 45.64423828-21.67734375 19.209375-36.65654297 33.66035156-44.93935547 43.7053711-11.27900391 13.74609375-19.56181641 27.31640625-24.67265625 40.7109375-6.87304688 17.79785156-10.39746094 39.12275391-10.39746093 63.61875 0 4.22929688 0.17578125 10.39746094 0.3515625 18.85693359h60.09609375c0.52734375-25.02509766 2.11464844-43.17626953 5.28662109-54.27949219 2.99707031-11.10234375 7.75458984-20.97070313 13.921875-29.60683593s19.56357422-21.853125 40.00605469-40.00517579c30.31171875-26.96308594 50.75507813-49.69775391 61.15341797-68.5546875 10.39746094-18.68027344 15.68408203-39.30029297 15.68408203-61.50498046 0-38.41962891-14.80341797-71.37421875-44.58691406-98.51396485-29.96015625-26.96484375-69.61289062-40.53515625-119.48554688-40.53515625z m-0.52910156 439.171875c-21.14824219 0-38.41962891 17.09472656-38.41962891 38.4196289 0 21.14824219 17.09472656 38.41875 38.41962891 38.41875 21.14736328 0 38.41875-17.09472656 38.41875-38.41875-0.17578125-21.14824219-17.27050781-38.41787109-38.41875-38.41787109z"
                      fill="var(--border-color)" p-id="2299"></path></svg>
                </span>
        </Tooltip>
      </div>
    </div>
  </Modal>
})

export const upgradeAmount = 0.7
const MinerList = React.memo(({small, stakingStatus, loading, upgrade}: {
  small: boolean,
  stakingStatus: string[] | undefined,
  loading: number[],
  upgrade: Function
}) => {
  const {miners, cycleBalance, blockMined, power, isNew} = useMinersStore()

  return <>
    <div className={"miner_list"}>
      <table>
        <thead>
        <tr>
          {miners && miners.length > 0 && title.map((e, i) => <th key={i}>{e}</th>)}
        </tr>
        </thead>
        <tbody>
        {miners?.map((v, k) => {
          let isDepleted = false
          const p = power ? power[k] : 1
          const pw = typeof p === "number" ? p.toFixed(2) : p
          const cycle = cycleBalance && cycleBalance[k] ? cycleBalance[k] : "-/-"
          let newCycle
          if (typeof cycle === "number") {
            if (cycle < cycleDeleted) isDepleted = true // 0.2 T
            newCycle = (cycle / 1e12).toFixed(3) + " Trillion"
          } else {
            newCycle = cycle
          }

          return <tr key={k}>
            <td style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
              <div style={{display: "flex"}}>
                {shortenString(v.toString(), small ? 5 : 10)}
                <Copy text={v.toString()}/>
              </div>
              {isNew ? <>
                {!isNew[k] ? loading.findIndex(e => e === k) === -1 ?
                  <Upgrade api={() => upgrade(isDepleted, v, k)}/> :
                  <Loading show={true}/> : null}
              </> : <Loading show={true}/>}

            </td>
            <td
              style={{color: isDepleted ? "#e6634f" : "var(--text-color)"}}>{isDepleted ? "Depleted" : newCycle}</td>
            <td
              style={{color: blockMined && blockMined[k] > 0 ? "white" : "var(--text-color)"}}>
              {blockMined ? blockMined[k] : "-/-"}
            </td>
            <td>{power ? (+pw === 1 ? "ICP subnet error" : pw) : "-/-"} </td>
            <td>{stakingStatus ? stakingStatus[k] : "-/-"} </td>
            {/*<td>{value[5]}</td>*/}
          </tr>
        })}
        </tbody>
      </table>
    </div>
    <div style={{display: "flex", justifyContent: 'center', marginTop: "20px"}}>
      <Loading show={miners === undefined}/>
    </div>
  </>
})


const MobileMinerList = React.memo(({stakingStatus, loading, upgrade}: {
  stakingStatus: string[] | undefined,
  loading: number[],
  upgrade: Function
}) => {
  const [show, setShow] = useState(-1)
  const {miners, cycleBalance, isNew, blockMined, power} = useMinersStore()

  return <>
    <div className={"mobile_miner_list"}>
      {miners && miners.length > 0 && <div className={"mobile_miner_head"}>
        Miners
      </div>}
      <div className={"mobile_miner_body"}>
        {miners?.map((v, k) => {
          let isDepleted = false
          const cycle = cycleBalance && cycleBalance[k] ? cycleBalance[k] : "-/-"
          let newCycle
          if (typeof cycle === "number") {
            if (cycle < cycleDeleted) isDepleted = true // 0.2 T
            newCycle = (cycle / 1e12).toFixed(3) + " Trillion"
          } else {
            newCycle = cycle
          }
          const p = power ? power[k] : 1
          const pw = typeof p === "number" ? p.toFixed(2) : p
          return <div key={k}>
            <div onClick={() => show === k ? setShow(-1) : setShow(k)}>
              {v.toString()}
              <div style={{display: "flex", alignItems: 'center'}}>
                {isNew ? <>
                  {!isNew[k] ? loading.findIndex(e => e === k) === -1 ?
                    <Upgrade api={(e) => {
                      e.stopPropagation()
                      upgrade(isDepleted, v, k)
                    }}/> :
                    <Loading show={true}/> : null}
                </> : <Loading show={true}/>}
                <Icon show={show === k}/>
              </div>
            </div>
            {show === k ? miners ? <Dropdown show={show === k} value={{
                "Cycle Balance": isDepleted ? "Depleted" : newCycle,
                "Block Mined": blockMined ? blockMined[k] : "-/-",
                "Power": power ? (+pw === 1 ? "ICP subnet error" : pw) : "-/-",
                "Staking Status": stakingStatus ? stakingStatus[k] : "-/-"
              }}/> :
              <div style={{display: "flex", justifyContent: 'center', marginTop: "20px"}}>
                <Loading show={miners === undefined}/>
              </div> : null}
          </div>
        })}
      </div>
    </div>
    <div style={{display: "flex", justifyContent: 'center', marginTop: "20px"}}>
      <Loading show={miners === undefined}/>
    </div>
  </>
})

const Icon = React.memo(({show}: { show: boolean }) => {
  return <div style={{
    display: 'flex',
    alignItems: 'center',
    transform: show ? "rotate(180deg)" : "",
    transition: 'all 0.2s linear'
  }}>
    <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
         p-id="4236" width="20px" height="20px">
      <path
        d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3 0.1-12.7-6.4-12.7z"
        p-id="4237" fill="var(--border-color)"></path>
    </svg>
  </div>
})

const Dropdown = React.memo(({show, value}: { show: boolean, value: Record<string, any> }) => {
  const ks = Object.keys(value)
  const vs = Object.values(value)

  return <div style={{display: show ? "flex" : "none"}} className={"dropdown_wrap"}>
    {ks.map((v, k) => {
      return <div key={k}>
        {v} : {vs[k] instanceof Array ? vs[k].length : vs[k]}
      </div>
    })}
  </div>
})

export const Copy = React.memo(({text}: { text: string }) => {
  const [copied, setCopied] = React.useState(false)
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true)
    } catch (e) {
    } finally {
      setTimeout(() => setCopied(false), 1000)
    }
  }

  return <Tooltip title={copied ? "copied!" : "copy"}>
    <div style={{display: "flex", alignItems: 'center', cursor: "pointer"}} onClick={copy}>
      <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
           p-id="4254" width="10px" height="10px">
        <path
          d="M878.250667 981.333333H375.338667a104.661333 104.661333 0 0 1-104.661334-104.661333V375.338667a104.661333 104.661333 0 0 1 104.661334-104.661334h502.912a104.661333 104.661333 0 0 1 104.661333 104.661334v502.912C981.333333 934.485333 934.485333 981.333333 878.250667 981.333333zM375.338667 364.373333a10.666667 10.666667 0 0 0-10.922667 10.965334v502.912c0 6.229333 4.693333 10.922667 10.922667 10.922666h502.912a10.666667 10.666667 0 0 0 10.922666-10.922666V375.338667a10.666667 10.666667 0 0 0-10.922666-10.922667H375.338667z"
          fill="var(--border-color)" p-id="4255"></path>
        <path
          d="M192.597333 753.322667H147.328A104.661333 104.661333 0 0 1 42.666667 648.661333V147.328A104.661333 104.661333 0 0 1 147.328 42.666667H650.24a104.661333 104.661333 0 0 1 104.618667 104.661333v49.962667c0 26.538667-20.309333 46.848-46.848 46.848a46.037333 46.037333 0 0 1-46.848-46.848V147.328a10.666667 10.666667 0 0 0-10.922667-10.965333H147.328a10.666667 10.666667 0 0 0-10.965333 10.965333V650.24c0 6.229333 4.693333 10.922667 10.965333 10.922667h45.269333c26.538667 0 46.848 20.309333 46.848 46.848 0 26.538667-21.845333 45.312-46.848 45.312z"
          fill="var(--border-color)" p-id="4256"></path>
      </svg>
    </div>
  </Tooltip>
})


const Upgrade = React.memo(({api}: { api: MouseEventHandler<HTMLDivElement> }) => {

  return <Tooltip title={"upgrade"}>
    <div style={{display: "flex", alignItems: 'center', cursor: "pointer"}} onClick={api}>
      <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
           p-id="3158" width="20px" height="20px">
        <path
          d="M896 490.666667c-4.266667 0-10.666667-2.133333-14.933333-6.4L514.133333 155.733333 142.933333 484.266667c-8.533333 8.533333-21.333333 6.4-29.866666-2.133334-8.533333-8.533333-6.4-21.333333 2.133333-29.866666l386.133333-341.333334c8.533333-6.4 19.2-6.4 27.733334 0l379.733333 341.333334c8.533333 8.533333 8.533333 21.333333 2.133333 29.866666-4.266667 6.4-8.533333 8.533333-14.933333 8.533334zM640 832H384c-12.8 0-21.333333-8.533333-21.333333-21.333333s8.533333-21.333333 21.333333-21.333334h256c12.8 0 21.333333 8.533333 21.333333 21.333334s-8.533333 21.333333-21.333333 21.333333z"
          fill="#1afa29" p-id="3159"></path>
        <path
          d="M384 490.666667H128c-12.8 0-21.333333-8.533333-21.333333-21.333334s8.533333-21.333333 21.333333-21.333333h256c12.8 0 21.333333 8.533333 21.333333 21.333333s-8.533333 21.333333-21.333333 21.333334zM896 490.666667H640c-12.8 0-21.333333-8.533333-21.333333-21.333334s8.533333-21.333333 21.333333-21.333333h256c12.8 0 21.333333 8.533333 21.333333 21.333333s-8.533333 21.333333-21.333333 21.333334zM640 917.333333H384c-12.8 0-21.333333-8.533333-21.333333-21.333333s8.533333-21.333333 21.333333-21.333333h256c12.8 0 21.333333 8.533333 21.333333 21.333333s-8.533333 21.333333-21.333333 21.333333z"
          fill="var(--border-color)" p-id="3160"></path>
        <path
          d="M640 746.666667H384c-12.8 0-21.333333-8.533333-21.333333-21.333334V469.333333c0-12.8 8.533333-21.333333 21.333333-21.333333s21.333333 8.533333 21.333333 21.333333v234.666667h213.333334V469.333333c0-12.8 8.533333-21.333333 21.333333-21.333333s21.333333 8.533333 21.333333 21.333333v256c0 12.8-8.533333 21.333333-21.333333 21.333334z"
          fill="var(--border-color)" p-id="3161"></path>
      </svg>
    </div>
  </Tooltip>
})

